import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit{
  title = 'GoHome';
  existImg = false;

  public constructor(){}
  
  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {

    checkIfImageExists('../assets/images/world_cup.jpg', (exists) => {
      if (exists) {
        this.existImg = true;
      } else {
        this.existImg = false;
      }
    });
  }

 
}

function checkIfImageExists(url, callback) {
  const img = new Image();
  img.src = url;
  
  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => {
      callback(true);
    };
    
    img.onerror = () => {
      callback(false);
    };
  }
}
